import axios from "axios";
import { BillingTariffInterface } from "../../interfaces/BillingTarifInterface";

const { REACT_APP_VEHICLES_API } = process.env;

export const getBillingTariffs = async (
  page = 1,
  filters,
  cancelToken,
  orderBy = "license",
  order = "asc",
) => {
  const url = `&results_per_page=30&page=${page}&order_by=${orderBy}&order=${order}`;
  const params = new URLSearchParams(url);
  if (filters) {
    params.set("filters", filters);
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/internal_tariffs?${params.toString()}`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: res.data,
      hasNextPage: res.data?.has_next_page,
      count: res.data?.count,
    };
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};

export const deleteBillingTariff = async (tariffId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/internal_tariffs/${tariffId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};

export const createBillingTariff = async (
  tariff: Omit<BillingTariffInterface, "_id">,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/internal_tariffs`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        ...tariff,
      },
    });
    return { data: response.data.data };
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};

export const updateBillingTariff = async (tariff: BillingTariffInterface) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/internal_tariffs/${tariff._id}`,
      headers: { Authorization: `Bearer ${token}` },
      data: tariff,
    });
    return { data: response.data.data };
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};
